import { render, staticRenderFns } from "./PassiveSkills.vue?vue&type=template&id=daf6ef2a&"
import script from "./PassiveSkills.vue?vue&type=script&lang=js&"
export * from "./PassiveSkills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports